import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var InboxUploadSvg = function InboxUploadSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 2.249 4.214 4.154-.986.973-2.53-2.494v6.592h-1.396V4.882l-2.53 2.494-.986-.973z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.442 12.62H2v9.629h20v-9.628h-7.442v1.604a2.5 2.5 0 0 1-.75 1.784 2.56 2.56 0 0 1-1.808.738 2.6 2.6 0 0 1-1.809-.738 2.49 2.49 0 0 1-.75-1.783zm-6.047 8.254v-6.878h4.652v.23c0 .511.102 1.018.3 1.49.2.474.49.903.857 1.265.368.362.803.65 1.283.845a4 4 0 0 0 4.309-.845c.367-.362.658-.791.857-1.264s.3-.98.3-1.492v-.229h4.652v6.877z",
    clipRule: "evenodd"
  }));
};
export var InboxUpload = function InboxUpload(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: InboxUploadSvg
  }));
};